import { useContext } from 'react';
import { CartContext } from 'providers/Cart';

const useCart = () => useContext(CartContext);

export default useCart;
